var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"color":"#256d7b"}},[_c('v-col',{staticClass:"text-center white--text",attrs:{"cols":"12"}},[_vm._v(" © 2019-2021 copyright S2A - "+_vm._s(_vm.$t("allright"))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }